var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { css, styled } from 'styled-components';
import { Down, Right } from '@hn-ui/icons';
import { formatDistance, parseISO } from 'date-fns';
import { useWeeklyDashboardAnalytics, WeeklyDashboardEvents, } from '../../../../hooks/useWeeklyDashboardAnalytics';
import { StudentName } from '../../../../../Common/components/StudentName';
import { STUDENT_NAME_MAX_VISIBLE_LENGTH } from '../../../../constants/views';
var Name = styled.div.withConfig({ displayName: "Name", componentId: "sc-6z7w5u" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: bold;\n  color: ", ";\n"], ["\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: bold;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.blue50;
});
var LastVisit = styled.p.withConfig({ displayName: "LastVisit", componentId: "sc-1prjezj" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n\n  font-size: 13px;\n  line-height: 16px;\n  letter-spacing: -0.2px;\n  margin: 0;\n  margin-left: 24px;\n  text-align: left;\n  white-space: nowrap;\n\n  ", "\n"], ["\n  color: ", ";\n\n  font-size: 13px;\n  line-height: 16px;\n  letter-spacing: -0.2px;\n  margin: 0;\n  margin-left: 24px;\n  text-align: left;\n  white-space: nowrap;\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black60;
}, function (_a) {
    var theme = _a.theme, $isOnline = _a.$isOnline;
    return $isOnline && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme.colors.green60);
});
var NameCell = function (_a) {
    var student = _a.student, isCurrentWeek = _a.isCurrentWeek, expanded = _a.expanded;
    var lastVisit = student.lastVisit;
    var sendGaEvent = useWeeklyDashboardAnalytics();
    return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    _jsxs("div", __assign({ onClick: function () {
            sendGaEvent(student.struggle
                ? WeeklyDashboardEvents.struggleStudentNameCellClick
                : WeeklyDashboardEvents.studentNameCellClick);
        } }, { children: [_jsx(StudentName, { name: student.fullName, maxLength: STUDENT_NAME_MAX_VISIBLE_LENGTH, renderName: function (name) { return (_jsxs(Name, __assign({ "data-name": 'student-name', onMouseEnter: function () {
                        sendGaEvent(WeeklyDashboardEvents.studentNameHover);
                    } }, { children: [expanded ? (_jsx(Down, { size: 20, className: 'arrow-icon' }, void 0)) : (_jsx(Right, { size: 20, className: 'arrow-icon' }, void 0)), name] }), void 0)); } }, void 0), isCurrentWeek &&
                (lastVisit ? (_jsx(OnlineStatus, { lastVisit: lastVisit }, void 0)) : (_jsx(LastVisit, { children: "-" }, void 0)))] }), void 0));
};
var OnlineStatus = function (_a) {
    var lastVisit = _a.lastVisit;
    var currentDate = new Date();
    var visitDate = parseISO(lastVisit);
    var timeDiff = currentDate.getTime() - visitDate.getTime();
    var isOnline = timeDiff <= 300000;
    var status = isOnline
        ? 'online now'
        : formatDistance(visitDate, currentDate, { addSuffix: true });
    return _jsx(LastVisit, __assign({ "$isOnline": isOnline }, { children: status }), void 0);
};
export { NameCell };
var templateObject_1, templateObject_2, templateObject_3;
